// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Staffing__root___OFM5R","mainContainer":"Staffing__mainContainer___jKAZp"};